var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WPBaseSwitch',{attrs:{"value":_vm.value,"left":_vm.left,"right":_vm.right,"disabled":_vm.disabled,"name":_vm.name,"lefttrue":_vm.lefttrue,"borderless":_vm.borderless},on:{"input":(val) => _vm.$emit('input', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }